import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Grid,
  styled,
  // Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import Scrollbars from "react-custom-scrollbars-2";
import { ColumnTitle, IconAction, IconApp, Modal, Pagination, WrapTable } from "../../";
import SaveIcon from "@mui/icons-material/Save";
import BoltIcon from "@mui/icons-material/Bolt";
// import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { useInfiniteQuery } from "react-query";
import { useMemo, useState } from "react";
import { UserService } from "../../../services/user/user.service";
import {
  useAddRestrictedUserEvse,
  useListUserEvse,
  useRemoveRestrictedUserEvse,
} from "../../../services/evse";
import { useDebounce } from "../../../hooks/useDebounce";
import { HeaderInfoChargepoint } from "./Header";
import { EAction } from "../../../types/enum";
import { usePermission } from "../../../hooks/CommonContext";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmDialog from "../../ModalConfirm";
import { convertToDateTime } from "../../../utils/datetime";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";

export const ModalRestrictedUser = (props: {
  open: boolean;
  onClose: () => void;
  init?: IEvse;
  selectTypeAuditLog: (arg: { type: string; action: string }) => void;
}) => {
  const evse = props.init;
  const [users, setUsers] = useState<any[]>([]);
  const [errorUsers, setErrorUsers] = useState<string[]>([]);
  const { value, setValue } = useDebounce({ initialValue: "", delay: 300 });
  const [page, setPage] = useState(1);
  const { mutateAsync } = useAddRestrictedUserEvse();
  const { mutateAsync: removeUserEvse } = useRemoveRestrictedUserEvse();
  const { data: listUserEvse, refetch, isFetching } = useListUserEvse({
    page,
    per_page: 5,
    evse_id: evse?._id,
  });
  const { restrictedUser } = usePermission();
  const queryClient = useQueryClient();

  const { data, hasNextPage, fetchNextPage } = useInfiniteQuery({
    queryKey: ["infinity_user", value],
    enabled: props.open && value?.trim() !== "" && value.length > 7,
    queryFn: ({ pageParam = 1 }) => fetchListUser({ pageParam, phone: value }),
    getNextPageParam: (currentPage, allPage) => {
      const check =
        (currentPage?.per_page || 0) * (currentPage?.page || 0) <
        (currentPage?.total || 0);
      return check ? allPage.length + 1 : undefined;
    },
  });

  const listUser: Array<{ name: string; _id: string; phone: number }> =
    useMemo(() => {
      const arr = data?.pages.map((page) => {
        return (
          page?.data.map((item: any) => ({
            _id: item._id,
            name: item.name || "Unknown",
            phone: item.phone || "Unknown",
          })) || []
        );
      });
      return arr?.flat() || [];
    }, [data?.pages]);

  const handleUpdate = async () => {
    if (users.length !== 0 && evse)
      try {
        const result = await mutateAsync({
          dto: { user_ids: users.map(u => u._id), evse_ids: [evse._id!] },
        });
        if (result) {
          if (result.warningData && Object.keys(result.warningData).length > 0) {
            const failedIdsFromApi = Object.values(result.warningData).flat().map(String);

            const usersToKeep = users.filter(u => failedIdsFromApi.includes(u._id));
            setUsers(usersToKeep);
            setErrorUsers(failedIdsFromApi);

            toast(result.message || "Some user(s) are already in the VIP list", { icon: "⚠️" });

            setTimeout(() => {
              setUsers([]);
              setErrorUsers([]);
            }, 3000);
          } else {
            setUsers([]);
            setErrorUsers([]);
            toast.success(result.message || "Add restricted users success!");
          }

          refetch();
          queryClient.invalidateQueries(['list_users_evse']);
        }
      } catch (error) {
        console.log("error", error);
      }
  };

  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  const _handleDeleteUser = async (userId: string) => {
    if (!evse) return;

    try {
      await removeUserEvse({
        dto: {
          user_ids: [userId],
          evse_ids: [evse._id!],
        },
      });
      refetch();
    } catch (error) {
      console.error("Failed to delete user:", error);
    }
  };

  const handleConfirmClose = async (confirmed: boolean) => {
    setOpenConfirm(false);
    if (confirmed && selectedUserId && evse) {
      try {
        await removeUserEvse({
          dto: {
            user_ids: [selectedUserId],
            evse_ids: [evse._id],
          },
        });
        refetch();
        queryClient.invalidateQueries(['list_users_evse']);
      } catch (error) {
        console.error("Failed to remove restricted user", error);
      } finally {
        setSelectedUserId(null);
      }
    } else {
      setSelectedUserId(null);
    }
  };
  return (
    <>
      <Modal
        {...props}
        name="Restricted Users"
        description="Manage users with restricted access due to account issues"
        icon={
          <IconApp width={"35px"} name={"RestrictedUsers"} color={"yellow"} />
        }
      >
        <Box display={"flex"} flexDirection="column" gap={"30px"}>
          <HeaderInfoChargepoint
            model={evse?.model}
            current_type={evse?.current_type}
            max_p={evse?.max_p}
            locationName={evse?.Location?.name}
            ampeco_evse_id={evse?.ampeco_evse_id}
          />

          <Box display={"flex"} flexDirection="column" gap={1}>
            <WrapTable isLoading={isFetching} height="100%">
              <TableContainer>
                <Scrollbars
                  autoHeight
                  autoHeightMin="100%"
                  autoHeightMax="100%"
                  style={{ width: "100%" }}
                  autoHide
                >
                  <Table sx={{ minWidth: 750, background: "none" }}>
                    <TableHead>
                      <TableRow>
                        <ColumnTitle align="center" sx={{ minWidth: 70 }}>
                          S/N
                        </ColumnTitle>
                        <ColumnTitle>User</ColumnTitle>
                        <ColumnTitle>Registered mobile no</ColumnTitle>
                        <ColumnTitle>Joined date</ColumnTitle>
                        <ColumnTitle align="center">Action</ColumnTitle>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listUserEvse?.data.map((item: any, index: number) => (
                        <TableRow>
                          <TableCell align="center">
                            {page * 5 - 5 + index + 1}
                          </TableCell>
                          <TableCell>{item.user_name}</TableCell>
                          <TableCell>{item.user_phone}</TableCell>
                          <TableCell>{convertToDateTime(item.joined_date)}</TableCell>
                          <TableCell align="center">
                            <IconAction
                              title="Delete User"
                              icon={<DeleteIcon />}
                              onClick={() => {
                                if (restrictedUser?.includes(EAction.DELETE)) {
                                  setSelectedUserId(item._id);
                                  setOpenConfirm(true);
                                } else {
                                  toast.error("Access not available for your role.");
                                }
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Scrollbars>
              </TableContainer>
            </WrapTable>
            <Pagination
              page={page}
              setPage={setPage}
              totalItems={listUserEvse?.total || 0}
              totalPage={Math.ceil((listUserEvse?.total || 0) / 5)}
              currentPage={page}
            />
          </Box>

          <Box display={"flex"} flexDirection="column" gap="15px">
            <Box display={"flex"} gap={1} alignItems="center">
              <BoltIcon fontSize="medium" />
              <Typography fontSize={"14px"}>
                Add restricted users{" "}
                <span style={{ color: "#9B9B9B" }}>
                  Enter The User’s Mobile Numberin Each Line To Add Him/ Her As A
                  “RU”
                </span>
              </Typography>
            </Box>
            <Box display={"flex"} flexDirection="column" gap={"16px"}>
              <Typography>Your mobile number</Typography>
              <Autocomplete
                  onChange={(_, value) => setUsers(value)}
                value={users}
                multiple
                limitTags={5}
                disableCloseOnSelect
                options={listUser}
                getOptionLabel={(option) => `${option.name} - ${option.phone}`}
                isOptionEqualToValue={(option, value) => option._id === value._id}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => {
                    const { key, ...tagProps } = getTagProps({ index });
                    const isError = errorUsers.includes(option._id);
                    return (
                      <Chip
                        key={key}
                        label={`${option.name} - ${option.phone}`}
                        color={isError ? "warning" : "default"}
                        sx={{
                          ...(isError && {
                            animation: 'blink 0.8s ease-in-out infinite',
                            '@keyframes blink': {
                              '0%': { opacity: 1 },
                              '50%': { opacity: 0.3 },
                              '100%': { opacity: 1 },
                            }
                          })
                        }}
                        {...tagProps}
                      />
                    );
                  })
                }
                ListboxProps={{
                  onScroll: (event: React.SyntheticEvent) => {
                    const listboxNode = event.currentTarget;
                    if (
                      listboxNode.scrollTop + listboxNode.clientHeight ===
                      listboxNode.scrollHeight
                    ) {
                      hasNextPage && fetchNextPage();
                    }
                  },
                }}
                onInputChange={(_, e) => setValue(e)}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Users" />
                )}
                fullWidth
              />
            </Box>
            {/* <Box display={"flex"} gap={1} alignItems="center"> */}
            {/*   <PersonAddAltIcon fontSize="medium" /> */}
            {/*   <Typography fontSize={"14px"}> */}
            {/*     Add the user to ALL charger in the location */}
            {/*   </Typography> */}
            {/*   <Switch defaultChecked /> */}
            {/* </Box> */}

            <Box
              display={"flex"}
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Box display={"flex"} gap={1} alignItems="center">
                <IconApp name="InfoCricle" width={11} height={11} color="white" />
                <Typography fontSize={"10px"} textTransform="capitalize">
                  To Make Changes To Electricity Tariff, Please Contact Your
                  Relationship Officer
                </Typography>
              </Box>
              <IconAction
                title="Audit Log"
                onClick={() =>
                  props.selectTypeAuditLog({
                    type: "evse",
                    action: "add_restricted_user",
                  })
                }
                icon={<IconApp name="History" width={20} height={20} />}
              />
            </Box>
          </Box>

          <Grid container spacing={2}>
            {restrictedUser?.includes(EAction.UPDATE) && (
              <Grid item xs={8}>
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  startIcon={<SaveIcon fontSize="large" />}
                  onClick={handleUpdate}
                  disabled={!evse || users.length === 0}
                >
                  Add more user
                </Button>
              </Grid>
            )}
            <Grid item xs={4}>
              {restrictedUser?.includes(EAction.DELETE) && (
                <Button
                  fullWidth
                  size="large"
                  variant="contained"
                  color="inherit"
                  onClick={props.onClose}
                >
                  Remove
                </Button>
              )}
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <ConfirmDialog
        open={openConfirm}
        title="Confirm Deletion"
        content="Are you sure you want to remove this restricted user?"
        onClose={handleConfirmClose}
      />
    </>
  );
};

const _Text = styled(Typography)({ color: "#9B9B9B" });
const _TextName = styled(Typography)({
  fontSize: "17px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

const fetchListUser = async ({
  pageParam,
  phone,
}: {
  pageParam: number;
  phone?: string;
}) => {
  try {
    const { data } = await UserService.getListUser({
      page: pageParam,
      per_page: 20,
      phone,
    });
    return data;
  } catch (error) {
    console.log("error", error);
  }
};
